import { transfersMiddleware as transferListMiddleware } from './transfers-middleware';

export const transfersMiddleware = [transferListMiddleware];
